import _ from "lodash";

/**
 * Get only the players that have been modified so that just these players get updated
 * @param {object} modified
 * @param {object} data
 * @returns {object}
 */
export const getModifiedPlayerData = (modified, data) => {
  const playerIndexes =
    Object.keys(modified)
      .filter(
        (path) => modified[path] && _.get(path.split("."), "0") === "players"
      )
      .map((path) => _.get(path.split("."), 1)) || [];

  return _.uniq(playerIndexes).map((playerIndex) => {
    const playerData = _.get(data, ["players", playerIndex]);
    return {
      id: playerData.id,
      data: playerData
    };
  });
};
